import React from "react";
import ChevronUpIcon from "@atlaskit/icon/glyph/chevron-up";
import ChevronDownIcon from "@atlaskit/icon/glyph/chevron-down";
import PageIcon from "@atlaskit/icon/glyph/page";
import append from 'ramda/src/append';

import { SubNav } from "./SubNav";
import { ListItemText } from "../../UI/ListItemText";

import { StyledListItemButton } from "./styles";
import { SUBNAV } from "./types";
import { ListItemIcon } from "../../UI/ListItemIcon";
import { REPORTS_SUBNAV_LINKS, URL } from "../../constants/navigation";
import useAuth from "../../routes/login/AuthContext";

interface IProps {
  subnavOpen?: SUBNAV;
  toogleSubnav: VoidFunction;
}

const getExpandLink = (open: boolean) =>
  open ? <ChevronUpIcon label="Chevron up" /> : <ChevronDownIcon label="Chevron down" />;

export const ReportsItem: React.FC<IProps> = (props) => {
  const [links, setLinks] = React.useState(REPORTS_SUBNAV_LINKS);
  const { isWriteAccess } = useAuth();

  const superAdminWrite = isWriteAccess();

  React.useEffect(() => {
    if (superAdminWrite) {
      setLinks(append({ name: "Activity Report", url: URL.DAILY_ACTIVITY_REPORT },));
    }
  }, [superAdminWrite]);

  return (
    <>
      <StyledListItemButton onClick={props.toogleSubnav}>
        <ListItemIcon>
          <PageIcon label="Reports" />
        </ListItemIcon>
        <ListItemText primary="Reports" />
        {getExpandLink(props.subnavOpen === SUBNAV.REPORTS)}
      </StyledListItemButton>
      <SubNav in={props.subnavOpen === SUBNAV.REPORTS} links={links} />
    </>
  );
};
